var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssessmentDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.998 1.073)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M611.629,1159.7a.231.231,0,0,0-.231.231v4.362a.231.231,0,1,0,.462,0v-4.362a.231.231,0,0,0-.231-.231Zm0,0",
    transform: "translate(-606.265 -1156.133)",
    fill: "#ff6060"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M493.629,1159.7a.231.231,0,0,0-.231.231v4.362a.231.231,0,1,0,.462,0v-4.362a.231.231,0,0,0-.231-.231Zm0,0",
    transform: "translate(-490.989 -1156.133)",
    fill: "#ff6060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.652,1007.933v5.686a1.273,1.273,0,0,0,.339.878,1.137,1.137,0,0,0,.825.357h4.367a1.136,1.136,0,0,0,.825-.357,1.273,1.273,0,0,0,.339-.878v-5.686a.882.882,0,0,0-.226-1.734h-1.182v-.288a.906.906,0,0,0-.914-.912h-2.049a.907.907,0,0,0-.914.912v.288h-1.182a.882.882,0,0,0-.226,1.734Zm5.53,6.459h-4.367a.731.731,0,0,1-.7-.773v-5.666h5.77v5.666a.731.731,0,0,1-.7.773Zm-3.66-8.482a.445.445,0,0,1,.452-.45h2.049a.445.445,0,0,1,.452.45v.288h-2.954Zm-1.643.75h6.241a.415.415,0,1,1,0,.831h-6.241a.415.415,0,0,1,0-.831Zm0,0",
    transform: "translate(-388.997 -1004.999)",
    fill: "#ff6060"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M552.629,1159.7a.231.231,0,0,0-.231.231v4.362a.231.231,0,1,0,.462,0v-4.362a.231.231,0,0,0-.231-.231Zm0,0",
    transform: "translate(-548.627 -1156.133)",
    fill: "#ff6060"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentDelete);
export default __webpack_public_path__ + "static/media/assessment_delete.28556a8e.svg";
export { ForwardRef as ReactComponent };